import type { Except } from '@festina-life/core'
import type { ComponentProps } from 'react'

import { type InputProps, InputWrapper } from '../inputWrapper/InputWrapper'
import { createInternalWrapperPropsAndId } from '../utility'
import { RawDateRangePicker } from './RawDateRangePicker'

type Props = Except<ComponentProps<typeof RawDateRangePicker>, 'renderInput'> &
  InputProps

export const DateRangePicker = ({ wrapperProps, ...fieldProps }: Props) => {
  const { internalWrapperProps, id, labelId } = createInternalWrapperPropsAndId(
    {
      wrapperProps,
      id: fieldProps.id,
    },
  )
  return (
    <RawDateRangePicker
      {...(!internalWrapperProps.label || fieldProps['aria-label']
        ? {}
        : { 'aria-labelledby': labelId })}
      {...fieldProps}
      id={id}
      renderInput={(input) => (
        <InputWrapper {...internalWrapperProps} labelType="reactAria">
          {input}
        </InputWrapper>
      )}
    />
  )
}
